/* eslint-env browser */
import { compactPhone } from '../components/modern/tableUtils';

// Call-centre feedback (29 Oct 2026): a phone number copied from a portal
// page pasted into MicroSIP with its spaces. The portal now shows numbers
// without spaces, but a number typed with spaces (a customer's "0911 23 45
// 67", a note) can still be on a page. One copy listener for the whole
// portal: when what is copied is ONE phone number, the clipboard gets it
// without spaces (+251964540448 / 0911234567). Any larger copy (a row, a
// table, a paragraph) is left exactly as the browser makes it, with its
// formatting; so is text copied from a box being typed in.
let installed = false;

const insideEditable = (node) => {
  let el = node && node.nodeType === 1 ? node : node && node.parentElement;
  while (el) {
    if (el.isContentEditable || el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') return true;
    el = el.parentElement;
  }
  return false;
};

export function installCompactPhoneCopy() {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener('copy', (e) => {
    try {
      if (insideEditable(document.activeElement)) return;
      const selection = window.getSelection ? window.getSelection() : null;
      if (!selection || selection.isCollapsed) return;
      if (insideEditable(selection.anchorNode)) return;
      const text = selection.toString().trim();
      // ONE number on one line: digits with spaces, dashes, dots or brackets,
      // 7 to 15 digits (a column of numbers is never run together).
      if (!/^\+?[\d \t \-().]+$/.test(text)) return;
      const digits = text.replace(/\D/g, '').length;
      if (digits < 7 || digits > 15) return;
      const compact = compactPhone(text);
      if (!compact || compact === text || !e.clipboardData) return;
      e.clipboardData.setData('text/plain', compact);
      e.preventDefault();
    } catch (err) {
      // never break copying: the browser copies the selection as it is
    }
  });
}
